/**
 * @author xiongxiaotao
 * 打开系统消息
 */
 import template from './system-message.html';
 import './system-message.scss';
 import Component from '../../../lib/component';
 import agGrid from '../../dataGrid/agGrid/agGrid';
 import dataPagination from '../../dataGrid/data-table-toolbar/data-pagination/data-pagination';
 import {systemMessageService} from '../../../services/main/systemMessage';
 import {PMAPI, PMENUM} from '../../../lib/postmsg';
 import msgbox from '../../../lib/msgbox';
 import {HTTP} from '../../../lib/http';
 import {dataTableService} from "../../../services/dataGrid/data-table.service"
 import Mediator from '../../../lib/mediator';
 import '../../../lib/fontsize'
 import AttachmentList from "../../form/attachment-list/attachment-list";
 import AttachmentControl from "../../form/attachment-control/attachment-control";
 import FloatingFilter from "../../dataGrid/data-table-toolbar/floating-filter/floating-filter";
 import {dgcService} from "../../../services/dataGrid/data-table-control.service";
 import msgBox from '../../../lib/msgbox';
 import ProjectManager from '../../customPage/project-manager/ProjectManager.jsx';
 import InvestmentAdvisor from '../../customPage/investment-advisor/InvestmentAdvisor.jsx';
 import reactDialog from '../../../lib/editableDialog';
 
 let gridPref;
 let SystemMessage = Component.extend({
     template: template,
     data:{
         frontendSort:true,      //排序方式（前端/后端）
         total:0,
         rows:100,
         getDataParams:{           //后端排序参数
             type:2,
             rows:100,
             first:0,
             currentPage:1,
             filter:JSON.stringify({})
         },
         tableId:'user-message',
         tabType: {'approve-workflow':1,'my-work':6,'system-push':2,'my-focus':5,'all-message':0},  //0全部消息，1待审批  6我的工作  2系统推送  5我关注的,
         step:1,
         //是否显示floatingfilter
         isShowFloatingFilter: false,
         //搜索参数
         filterParam: {expertFilter:[], filter: [], is_filter: 0, common_filter_id: '', common_filter_name: ''},
         //floatingFilter搜索参数
         searchValue: [],
         //floatingFilter搜索参数
         searchOldValue: [],
         //floatingFilter搜索参数
         queryList: {},
         //搜索参数(判断是否需要重置分页)
         filterText: '',
         columnDefs: [],
     },
     binds:[{
         event:'click',
         selector:'.markRead',//标为已读
         callback:function () {
             this.actions.markRead();
         }
     },{
         event:'click',
         selector:'.batchApprove',//批量审批
         callback:function () {
             this.actions.batchApprove();
         }
     },{
         event:'click',
         selector:'.batchDelete',//批量删除
         callback:function () {
             this.actions.batchDelete();
         }
     },{
         event:'click',
         selector:'.float-search-btn',//筛选
         callback:function () {
             if (this.data.isShowFloatingFilter && this.data.filterParam.filter.length != 0) {
                 for( let k in this.data.searchValue ){
                     this.data.searchValue[k] = '';
                 }
                 for( let k in this.data.searchOldValue ){
                     this.data.searchOldValue[k] = '';
                 }
                 this.data.queryList = {};
                 this.actions.setFloatingFilterInput();
                 this.data.filterParam.filter = [];
                 this.data.getDataParams.filter=JSON.stringify({});
                 this.actions.loadData(this.data.getDataParams,this.data.step,true)
             }
             let height = this.data.isShowFloatingFilter ? 0:30;
             this.agGrid.gridOptions.api.setFloatingFiltersHeight(height);
             this.data.isShowFloatingFilter = !this.data.isShowFloatingFilter;
         }
     }
     ],
     actions: {
         /**
          * 根据参数（type）向后台发送请求，获取渲染该页所需数据
          * @param _param
          */
         liClick: function () {
             this.el.find( '.system-message .tab-title li a' ).on( 'click',($event)=>{
                 let as = this.el.find( '.tab-title li a' );
                 this.data.step++;
                 for( let a of as ){
                     if(a.id == $event.target.id){
                         a.className = 'select';
                         this.data.getDataParams.type = this.data.tabType[$event.target.id];
                        // console.log('该tab页，消息类型',this.data.getDataParams.type)
                         this.actions.renderAgGrid(this.data.getDataParams.type)
                         this.actions.renderButton(this.data.getDataParams.type)
                         this.actions.loadData(this.data.getDataParams,this.data.step);
                     }else{
                         a.className = ''
                     }
                 }
             } )
         },
         /**
          * 根据参数（页码）向后台发送请求，获取渲染该页所需数据
          * @param _param
          */
         loadData: async function (param,index=1,isFilter = false) {
             // _param = _param || {};
             // let param = _.defaultsDeep(_param, {
             //     rows: this.pagination.data.rows,
             //     first: (this.pagination.data.currentPage - 1) * this.pagination.data.rows,
             //     currentPage: this.pagination.data.currentPage
             // });
             if(!isFilter) {
                 this.showLoading();
             }
             await systemMessageService.getMyMsg(param).then((data) => {
                 if(this.data == undefined || data == undefined){
                     return;
                 }
                 //筛选data.rows内容，处理 <!--[if gte mso 9]><xml></xml><![endif]-->多余代码
                 // if (data.total==0)return;
                 for (let i of data.rows) {
                     let content1 = i.msg_content;
                     let content2 = i.original_content;
                     //解决如果content1/content2为空，报错问题
                     if (!_.isEmpty(content1)||!_.isEmpty(content2)){
                         i.msg_content = this.actions.handleContent(content1, content2).str1;
                         i.original_content = this.actions.handleContent(content1, content2).str2;
                     }
                 }
                 console.log(index);
                 console.log(this.data.step);
                 if(index != this.data.step){
                     this.hideLoading();
                     return;
                 }
                 this.data.total = data.total;
                 this.actions.setSortModel();
                 this.agGrid.actions.setGridData({
                     rowData: data.rows
                 });
                 
                 this.pagination.actions.setPagination(data.total, param.currentPage);
                 this.hideLoading();
                 if(window.innerWidth > 1525) {
                     this.agGrid.gridOptions.api.sizeColumnsToFit();
                 }
                 this.el.find('.ag-overlay-wrapper').css({"display": "flex", "flexDirection": "column", "justifyContent": "center","height":"100%"})
                 this.el.find('.ag-overlay-no-rows-center').css({"height":"240px"})
             });
         },
         //渲染页面前处理后台传过来的<!--[if gte mso 9]><xml></xml><![endif]-->或者<!--[if gte mso 10]>代码
         /*
         * params:str1 富文本编辑器的样式
         * params:str2 富文本编辑器内容
         * */
         handleContent:function(str1,str2){
             if (str2.includes('<![endif]-->')){
                 //去除msg_content样式里的多余代码
                 str1 = str1.replace(/<xml>[\s\S]*?<\/xml>/ig, '');
                 str1=str1.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g','');
                 let reg=new RegExp('<!--(.*?)-->','g')
                 str1=str1.replace(reg,'');
                 //去除original_content文本里的多余代码
                 let word1='<!--[if gte mso 9]>';
                 let word2='<!--[if gte mso 10]>';
                 let word3='<![endif]-->';
                 if (str2.includes(word1)) {
                     str2=this.actions.cancelWordStyle(str2,word1,word3);
                 }
                 else if (str2.includes(word2)) {
                     str2=this.actions.cancelWordStyle(str2,word2,word3);
                 }
                 return {str1,str2}
             }
             else {
                 return {str1,str2}
             }
         },
         //递归去除<!--[if gte mso 10]>
         cancelWordStyle:function(str2,word1,word2){
              if (str2.includes(word1)) {
                 str2=str2.replace(word1,'');
                 str2=str2.replace(word2,'');
 
                 if (str2.includes(word1)) {
                     str2=this.actions.cancelWordStyle(str2,word1,word2)
                     return str2;
                 }
                 else return str2;
             }
             else return str2;
         },
         setSortModel:function () {
             if(this.data.total > this.data.rows){
                 this.data.frontendSort = false;
             }else{
                 this.data.frontendSort = true;
             }
             this.agGrid.gridOptions["enableServerSideSorting"] = !this.data.frontendSort;
             this.agGrid.gridOptions["enableSorting"] = this.data.frontendSort;
         },
         /**
          * 将选中信息标记为已读状态
          */
         markRead: function () {
             let unread_count = 0;
             msgbox.confirm('是否将选中的消息标为已读？').then((res) => {
                 if (res) {
                     let rows = this.agGrid.gridOptions.api.getSelectedRows();
                     let checkIds = rows.map((item) => {
                         if(item.is_read === 0){
                             unread_count++;
                         }
                         return item.id;
                     });
                     //保持window.config中unread数量正确
                     window.top.config.sysConfig.unread_msg_count = window.top.config.sysConfig.unread_msg_count - unread_count;
                     Mediator.emit("sysmsg:refresh_unread");
                     this.actions._postReadData(JSON.stringify(checkIds));
                 }
             });
         },
         /**
          * 向后台发送信息阅读状态，审批通过获取数据刷新页面
          * @param ids
          * @param type
          * @private
          */
         _postReadData: function (ids) {
             this.showLoading();
             let that = this;
             HTTP.postImmediately('/remark_or_del_msg/', {
                 checkIds: ids
             }).then((res) => {
                 this.hideLoading();
                 if (res.success === 1) {
                     this.data.step++;
                     that.actions.loadData(that.data.getDataParams,this.data.step);
                 }
             });
         },
         /**
          * 向后台发送信息阅读状态,前端自己刷新页面
          * @param ids
          * @private
          */
         _justPostReadData:function (ids) {
             HTTP.postImmediately('/remark_or_del_msg/', {
                 checkIds: ids
             })
         },
         /**
          * 批量审批，符合勾选规则后跳至工作流页面，审批完成后，刷新数据
          */
         batchApprove: function () {
             let rows = this.agGrid.gridOptions.api.getSelectedRows();
             let checkIds = this.actions._getCheckId(rows);
             let obj = {};
             if(checkIds.length === 0){
                 msgbox.alert('请选择至少一条“待审批”消息进行审批');
                 return;
             }
 
             //检测是否含有非待审批状态的消息被勾选
             for(let k of rows){
                 if(k.handle_status_text !== '待审批'){
                     msgbox.alert('勾选消息必须全部为“待审批”状态才能进行批量审批');
                     return;
                 }
             }
             obj.appovArray = checkIds;
             obj.type = 0;
             this.actions._openApproveDialog(JSON.stringify(obj));
         },
         _getCheckId:function (rows) {
              return rows.map((item) => {
                 return item.id;
             });
         },
         _openApproveDialog:function(data){
             PMAPI.openDialogByIframe('/iframe/multiapp/',{
                 width: 540,
                 height: 410,
                 title: '批量审批',
                 // customSize:true
             },data).then(res => {
                 if(res.refresh === true){
                     this.data.step++;
                     this.actions.loadData(this.data.getDataParams,this.data.step);
                 }
             });
         },
         /**
          * 批量删除，请求后台删除成功后，刷新页面
          */
         batchDelete: function () {
 
             msgbox.confirm('是否批量删除选中的消息？').then((res) => {
                 if (res) {
                     let checkIds = this.actions._getCheckId(this.agGrid.gridOptions.api.getSelectedRows());
                     HTTP.postImmediately('/remark_or_del_msg/', {
                         checkIds: JSON.stringify(checkIds),
                         is_del: 1
                     }).then((res) => {
                         if (res.success === 1) {
                             this.data.step++;
                             this.actions.loadData(this.data.getDataParams,this.data.step);
                         }
                     });
                 }
             });
         },
         /**
          * 分页组件监听页码改变后，根据页码请求数据
          * @param data
          */
         onPaginationChanged: function (data) {
             this.data.step++;
             this.data.getDataParams = _.defaultsDeep(data,this.data.getDataParams);
             this.data.rows = data.rows;
             this.actions.loadData(this.data.getDataParams,this.data.step);
         },
         /**
          * 根据消息数量和每页显示数量进行前端排序或后端排序
          * @param $event
          */
         onSortChanged:function ($event) {
             //分情况进行前端排序或后端排序
             if(!this.data.frontendSort){
                 this.data.step++;
                 //后端排序
                 console.log('启用后端排序');
                 let data = this.agGrid.gridOptions.api.getSortModel()[0];
                 this.data.getDataParams = {
                     rows: this.pagination.data.rows,
                     currentPage: this.pagination.data.currentPage,
                     first: (this.pagination.data.currentPage - 1) * this.pagination.data.rows,
                     type:this.data.getDataParams.type
                 };
                 if( data && data.sort === "asc" ){
                     this.data.getDataParams['sortOrder'] = 1;
                 }else if(data && data.sort === "desc"){
                     this.data.getDataParams['sortOrder'] = -1;
                 }
                 data.colId && (this.data.getDataParams['sortField']=data.colId);
                 this.actions.loadData(this.data.getDataParams,this.data.step);
             }else{
                 //前端排序
                 console.log('启用前端排序');
                 this.agGrid.actions.refreshView();
             }
         },
         //渲染颜色
         setRowStyle: function (param) {
             if (param.data.wf_urgency_level == 2) {
                 return {background: '#FFB5C5'};
             } else if (param.data.wf_urgency_level == 1) {
                 return {background: '#FCF5A5'};
             }
         },
         /**
          * 双击打开消息细节弹窗
          * @param $event
          */
         onRowDoubleClicked:function ($event) {
             this.actions.openDialog($event);
         },
         /**
          * 选择信息查看详细内容，信息类型不同，采用不同方式展示
          * @param $event
          */
         onCellClicked: function ($event) {
             if($event.colDef.headerName === '操作'){
                 this.actions.openDialog($event.data);
             }
             if($event.colDef.headerName === '附件') {
                 this.actions.openAttachment($event)
             }
         },
         /**
          * 根据消息类型按不同方式展示具体消息
          * @param $event
          * state  true来自首页的点击
          */
         openDialog:function (data,state) {
             console.log('查看操作');
             // let data = $event.data;
             // if ((data.handle_status_text === '待审批' || data.handle_status_text === '已通过' || data.handle_status_text === '已取消' ||
             //     data.handle_status_text === '已驳回' || data.handle_status_text === '已完成') || data.msg_type === '关注消息') {
             this.actions._calUrl(data);
             // 查看操作通过前端自己刷新未读，审批通过loadData刷新
             this.actions._freshUnread(data,state);
         },
         _calUrl:function (data) {
             if (data.msg_type === '审批消息' || data.msg_type === '关注消息' || data.msg_type === '传阅消息') {
                 if(data.handle_status_text === '待审批'){
                     data.url += "&btnType=edit";
                 }else if(data.handle_status_text === '已取消'){
                     data.url += "&btnType=view";
                 }else if(data.handle_status_text === '已被通过' || data.handle_status_text === '已通过' || data.handle_status_text === '其他'|| data.handle_status_text === '已驳回'){
                     data.url += "&btnType=view";
                 } else {
                     data.url += "&btnType=view";
                 }
                 this.actions._openView(data);
             } else {
                 systemMessageUtil.showMessageDetail(data.msg_type_text, data);
             }
         },
         _openView:function (data) {
            let title=data.msg_type;
            if(data.msg_type=='审批消息'){
                title='审批工作'
                console.log('approve message', data)
                let params_str = data.url.split('?')[1]
                let params_list =  params_str.split('&')
                let param_dict = {}
                params_list.map(param => {
                    var k_v = param.split('=')
                    param_dict[k_v[0]] = k_v[1]
                })
                let data_type = null, isEdit = false;
                if(data.handle_status_text == '待审批'){
                    data_type = 'approve'
                    isEdit = true
                }
                //中信信托项目管理新增
                if(param_dict['table_id'] == '9364_MHTHP6HEiftxQyrbeQwm78'){
                    let theModel = reactDialog;
                    theModel.show({
                        title: '项目管理',
                        el: ProjectManager,
                        isEdit: isEdit,
                        record_id: data["record_id"],
                        flow_id: data["flow_id"],
                        showRecord: true,
                        isFrom: 'workflow',
                        type: data_type,
                        w: window.innerWidth * 0.9,
                        h: window.innerHeight * 0.8,
                        event: {
                            closeDialog() {
                                theModel.hide();
                            }
                        }
                    })
                    return;
                }
                //投资顾问流程
                if(param_dict['table_id'] == '3758_gZzndkxkm8ndk6FBcQymy4'){
                    let theModel = reactDialog;
                    theModel.show({
                        title: '投资顾问',
                        el: InvestmentAdvisor,
                        isEdit: isEdit,
                        record_id: $event["data"]["id"],
                        flow_id: $event["data"]["flow_id"],
                        showRecord: true,
                        w: window.innerWidth * 0.9,
                        h: window.innerHeight * 0.8,
                        isFrom: 'workflow',
                        type: data_type,
                        event: {
                            closeDialog() {
                                theModel.hide();
                            }
                        }
                        
                    })
                    return;
                }
            }
            PMAPI.openDialogByIframe(data.url, {
                 width: 1200,
                 height: 500,
                 title: title,
                 customSize:true
            }).then((result) => {
                 if (result.refresh === true) {
                     this.data.step++;
                     setTimeout(()=>{this.actions.loadData(this.data.getDataParams,this.data.step);},500)
                 }
            })
         },
         openAttachment:function (data) {
             let fileIds = data.data.attachment;
             let dinput_type = 9;
             let json = {
                 file_ids: JSON.stringify(fileIds),
                 dinput_type: dinput_type
             }
             let w, h;
             if (window.innerWidth < 1300) {
                 w = 800;
                 h = 600;
             }
             if (fileIds) {
                 systemMessageService.getAttachmentList(json).then(res => {
                     let list = res["rows"];
                     for (let data of list) {
                         //附件名称编码转换
                         data.file_name = data.file_name;
                         let str = systemMessageService.getFileExtension(data.file_name);
                         if (systemMessageService.preview_file.indexOf(str.toLowerCase()) != -1) {
                             data["isPreview"] = true;
                             if (systemMessageService.preview_file.indexOf(str.toLowerCase()) < 4) {
                                 data["isImg"] = true;
                             } else {
                                 data["isImg"] = false;
                             }
                         } else {
                             data["isPreview"] = false;
                         }
                     }
                     AttachmentList.data.list = list;
                     AttachmentList.data.dinput_type = dinput_type;
                     AttachmentList.data.is_view = true;
                     AttachmentList.data.record_type = '来源：消息列表';
                     PMAPI.openDialogByComponent(AttachmentList, {
                         width: w || 1400,
                         height: h || 800,
                         title: '附件列表'
                     })
                 });
                 HTTP.flush();
             }
         },
         _freshUnread:function (data,state) {
             if(data.handle_status_text !== '待审批'){
                 if(data.is_read === 0){
                     data.is_read = 1;
                     if (!state)this.agGrid.actions.refreshView();
                     window.top.config.sysConfig.unread_msg_count--;
                     Mediator.emit("sysmsg:refresh_unread");
                     this.actions._justPostReadData(JSON.stringify([data.id]));
                 }
             }else{
                 if(data.is_read === 0){
                     window.top.config.sysConfig.unread_msg_count--;
                 }
                 this.actions._postReadData(JSON.stringify([data.id]));
             }
             if(data.wf_urgency_level == 1){
                 msgbox.alert('催办消息：' + (data.urge_info||''));
             }
         },
         /**
          * 根据用户偏好初始化分页工具
          */
         initPagination:async function () {
             this.data.step++;
             this.pagination = new dataPagination({
                 data: {
                     currentPage: 1,
                     rows: this.data.rows,
                     tableId:this.data.tableId
                 }
             });
             this.pagination.render(this.el.find('.pagination'));
             this.pagination.actions.paginationChanged = this.actions.onPaginationChanged;
             this.data.getDataParams.rows = this.data.rows;
             await this.actions.loadData(this.data.getDataParams,this.data.step);
             this.hideLoading();
         },
         _getPreferences:function () {
             let tempData = {
                 actions:JSON.stringify(['pageSize']),
                 table_id:this.data.tableId
             };
 
             dataTableService.getPreferences(tempData).then((result) => {
                 if(result.success === 1 && result.pageSize !== null){
                     this.data.rows = result.pageSize.pageSize;
                 }
                 if(this.actions == undefined){
                     return;
                 }
                 this.actions.initPagination();
             });
             HTTP.flush();
         },
         renderAgGrid: function (type) {
             this.data.isShowFloatingFilter = false;
             let gridDom = this.el.find('.grid');
             let $div = $('<div></div>');
             gridDom.append($div);
             let that = this;
             let columnDefs = [];
             this.data.searchValue = [];
             this.data.searchOldValue = [];
             this.data.queryList = {};
             this.data.filterParam.filter = [];
             this.data.getDataParams.filter = JSON.stringify({});
             columnDefs = systemMessageService.getColumnDefs(type);
             columnDefs.forEach(item=>{
                 item['floatingFilterComponent'] = this.floatingFilterCom.actions.createFilter(item.filterType, item["field"], this.data.searchValue, this.data.searchOldValue);
                 item['floatingFilterComponentParams'] = {suppressFilterButton: true};
             })
             let number = dgcService.numberCol;
             dgcService.numberCol['headerCellTemplate'] = this.actions.resetPreference();
             if(columnDefs.indexOf(number) == -1 || columnDefs.indexOf(dgcService.selectCol) == -1) {
                 columnDefs.unshift(number,dgcService.selectCol);
             }
             if (this.agGrid) {
                 this.agGrid.destroySelf();
             }
             //设置表格表头信息
             gridPref = this.agGrid = new agGrid({
                 data:{
                     columnDefs: columnDefs,
                     onCellClicked: that.actions.onCellClicked,
                     noFooter: true,
                     floatingFilter: true,
                     setRowStyle: this.actions.setRowStyle,
                     onRowDoubleClicked:that.actions.onRowDoubleClicked,
                     onSortChanged: this.actions.onSortChanged,
                     footerData:[]
                 }
             });
             this.agGrid.render($div);
             if (window.innerWidth < 1525) {
                this.el.find('.grid').css({
                    // 'height': 'calc(100% - 150px)',
                    'height':'432px',
                    'width': 'calc(100% - 0px)'
                });
             }
         },
         renderButton(type) {
             let dom
             if(type === 1) {
                 dom = `<button class="markRead">标为已读</button>
                         <button class="batchApprove">批量审批</button>
                         <button class="batchDelete">删除</button>`;
             }else {
                 dom = `<button class="markRead">标为已读</button>
                         <button class="batchDelete">删除</button>`;
             }
             this.el.find('.bar').html(dom);
         },
         //floatingFilter拼参数
         floatingFilterPostData: function (col_field, keyWord, searchOperate) {
             this.data.getDataParams.filter = [];
             this.data.queryList[col_field] = {
                 'keyWord': keyWord,
                 'col_field': col_field
             };
             //用于去除queryList中的空值''
             let obj = {};
             for (let key in this.data.queryList) {
                 if (!( this.data.queryList[key]["keyWord"] == "" )) {
                     obj[key] = this.data.queryList[key];
                 }
             }
             this.data.queryList = obj;
             let filter = [];
             for (let attr in this.data.queryList) {
                 filter.push({
                     "cond": {
                         "leftBracket": 0,
                         "searchBy": this.data.queryList[attr]['col_field'],
                         "keyword": this.data.queryList[attr]['keyWord'],
                         "rightBracket": 0
                     }
                 });
             }
             this.data.filterParam['filter'] = filter;
             this.data.filterParam['is_filter'] = 1;
             this.data.getDataParams.filter = this.data.filterParam['filter'];
             this.data.getDataParams =this.actions.returnQueryParams( this.data.getDataParams );
             this.actions.loadData(this.data.getDataParams,this.data.step,true)
         },
         bindScrollTimer(){
             this.el.find('.ag-body-viewport').on('scroll',(event)=>{
                 if(this.data.scrollTimer){
                     clearTimeout(this.data.scrollTimer);
                 }
                 this.data.scrollTimer=null;
                 this.data.scrollTimer=setTimeout(()=>{
                     this.actions.setFloatingFilterInput();
                 },100)
             })
         },
         //设置搜索input值
         setFloatingFilterInput: function () {
             for( let k in this.data.searchValue ){
                 try{
                     this.el.find( '.filter-input-'+k )[0].value = this.data.searchValue[k];
                     if(k == 'handle_status_text') {
                         this.el.find( '.filter-input-'+k )[1].value = this.data.searchValue[k];
                     }
                 }catch(e){}
             }
         },
         resetPreference(){
             let ediv = document.createElement('div');
             let eHeader = document.createElement('span');
             let eImg = document.createElement('i');
             eImg.title = '重置筛选';
             eImg.className = 'icon-aggrid icon-aggrid-cancel resetFloatingFilter';
             eImg.addEventListener( 'click',()=>{
                 msgBox.confirm( '确定清空筛选数据？' ).then( r=>{
                     if( r ){
                         for( let k in this.data.searchValue ){
                             this.data.searchValue[k] = '';
                         }
                         for( let k in this.data.searchOldValue ){
                             this.data.searchOldValue[k] = '';
                         }
                         this.data.queryList = {};
                         this.actions.setFloatingFilterInput();
                         this.data.filterParam.filter = [];
                         this.data.getDataParams.filter = JSON.stringify({});
                         this.actions.loadData(this.data.getDataParams,this.data.step,true);
                     }
                 } )
             } );
             ediv.appendChild( eHeader );
             eHeader.innerHTML = "序号";
             ediv.appendChild( eImg );
             return ediv;
         },
         //搜索filter
         returnQueryParams: function (queryParams) {
             if(queryParams.filter){
                 let temp = {};
                 if(queryParams.filter.length != 0 && !queryParams.filter['_id']){
                     temp = this.actions.translateAdvancedQuery(queryParams.filter);
                 }else if( queryParams.filter['_id'] ) {
                     temp = queryParams.filter;
                 }else {
                     temp = {};
                 }
                 queryParams.filter = JSON.stringify(temp);
                 if( queryParams.filter == '{}' ){
                     delete queryParams.filter;
                 }
                 return queryParams;
             }
         },
         translateAdvancedQuery: function (oldQueryList) {
             let tempDictAndPinyin = [];
             let tempDict = {};
             for (let i in oldQueryList) {
                 let searchDict = oldQueryList[i];
                 let cond = searchDict["cond"];
                 let searchBy = cond["searchBy"];
                 let keyword = cond["keyword"];
                 if(searchBy == 'original_content') {
                     searchBy ='msg_content';
                 }
                 tempDict[searchBy] = keyword;
                 tempDictAndPinyin.push(tempDict);
             }
             return tempDict;
         },
     },
     afterRender:function () {
         this.floatingFilterCom = new FloatingFilter();
         this.floatingFilterCom.actions.floatingFilterPostData = this.actions.floatingFilterPostData;
         this.actions.renderButton(this.data.getDataParams.type)
         this.actions.renderAgGrid(this.data.getDataParams.type)
         this.showLoading();
         this.actions.liClick();
         //请求页显示数量偏好
         this.actions._getPreferences();
         this.actions.bindScrollTimer();

        Mediator.subscribe('bs_color',async (res)=>{
            console.log(res);
        })
     }
 });
 
 export default SystemMessage
 let systemMessageUtil = {
     el: null,
     show: function () {
         let w, h;
         if (window.innerWidth < 1525) {
             w = 900;
             h = 630;
         }
         this.el = $("<div class='user-system-message'>").appendTo('body');
         let systemMessage = new SystemMessage();
         systemMessage.render(this.el);
         let sysDom = this.el.find('.system-message');
         this.el.erdsDialog({
             width: w || 1400,
            //  height: h || 830,
            height: h || 620,
             modal: true,
             maxable: true,
             defaultMax: false,
             customSize: false,
             title: '消息提醒',
             resizeMax:function () {
                 sysDom.addClass('maximize-model');
                 systemMessageUtil._resizeColumns(systemMessage);
             },
             resizeMin:function () {
                 sysDom.removeClass('maximize-model');
                 if(window.innerWidth > 1525) {
                     systemMessageUtil._resizeColumns(systemMessage);
                 }
             },
             close: function () {
                 $(this).erdsDialog('destroy');
                 systemMessage.destroySelf();
             }
         })
     },
     hide: function () {
 
     },
     _resizeColumns:function (systemMessage) {
         systemMessage.showLoading();
         setTimeout(function () {
             gridPref.gridOptions.api.sizeColumnsToFit();
             systemMessage.hideLoading();
         },500);
     },
     /**
      * 传入单条消息或消息数组，进行显示和朗读
      * @param dialogTitle
      * @param data
      * @param speak
      */
     showMessageDetail: function (dialogTitle, data,speak = false,isDealPostMsg=false) {
         console.log('postmsg')
         console.log(data)
         let record_type = '来源：消息列表';
         if(dialogTitle == '推送消息'){
             record_type = '来源：消息弹窗';
         }
         let obj = systemMessageUtil._getHtmlAndMsg(data);
         systemMessageUtil._speak(speak,obj.readMsg);
         this.el = $(obj.html).appendTo('body');
         this.el.find('component-msg-detail').css('position','relative');
         this.el.find('.showSenderName').css({'position':'absolute','right':'80px','bottom':'20px','top':'auto'});
         if($.isArray(data) === false){
             let attachmentLists;
             if(data.attachment){
                 attachmentLists = data.attachment;
             }else {
                 attachmentLists = data.attachment_ids;
             }
             if(attachmentLists) {
                 if(attachmentLists.length >0){
                     systemMessageUtil._getAttachmentLists(attachmentLists,0,record_type);
                     this.el.find('.showSenderName').css('bottom','150px');
                 }else {
                     this.el.find('.msg-wrap .text').css('max-height','380px');
                     this.el.find('.attachment').hide();
                 }
             }else {
                 this.el.find('.msg-wrap .text').css('max-height','400px');
                 this.el.find('.showSenderName').css('bottom','10px');
                 this.el.find('.attachment').hide();
             }
         }else{
             data.forEach((msg,index)=>{
                 if(msg.attachment_ids) {
                     if(msg.attachment_ids.length >0){
                         systemMessageUtil._getAttachmentLists(msg.attachment_ids,index,record_type);
                         this.el.find('.showSenderName').css('bottom','150px');
                     }else {
                         $(this.el.find('.attachment')[index]).hide();
                     }
                 }else {
                     $(this.el.find('.attachment')[index]).hide();
                 }
             })
         }
         if(isDealPostMsg && data.length>1){
             $('.component-msg-detail .text').css({'overflow-y':'hidden','max-height':'none'});
             $('.showSenderName').css({'position':'inherit','right':'auto','bottom':'auto','float':'right'});
             $('.component-msg-detail .attachment').css({'position':'relative'})
         }
         let that = this;
         this.el.erdsDialog({
             width: 900,
             height: 600,
             modal: true,
             title: dialogTitle,
             close: function () {
                 //关闭语音提示
                 speechSynthesis.cancel();
                 //关闭自动弹出消息框   向后台发送阅读状态；
                 if (dialogTitle) {
                     let id = [];
                     id.push(data.msg_id);
                     HTTP.postImmediately('/remark_or_del_msg/', {
                         checkIds: JSON.stringify(id),
                     })
                 }
                 $(this).erdsDialog('destroy');
                 $(this).remove();
             }
         })
     },
     _getHtmlAndMsg:function(data){
         let html = '<div class="component-msg-detail"><div class="msg-wrap">';
         let readMsg = '';
         if($.isArray(data) === false){
             if(!data.content){
                 data.content = data.msg_content;
             }
             html += systemMessageUtil._getHtml(data) + `</div>`;
             if(data.original_content) {//去除content里的style标签
                 readMsg = data.title.replace(/&nbsp;/g, '').toString() + data.original_content.replace(/&nbsp;/g, '').replace(/<style>[\s\S]*?<\/style>/ig, '').toString();
             }else {
                 readMsg = data.title.replace(/&nbsp;/g, '').toString() + data.content.replace(/&nbsp;/g, '').replace(/<style>[\s\S]*?<\/style>/ig, '').toString();
             }
         }else{
             for(let msg of data){
                 html += systemMessageUtil._getHtml(msg);
                 readMsg += msg.title.replace(/&nbsp;/g, '').toString() + msg.content.replace(/&nbsp;/g, '').replace(/<style>[\s\S]*?<\/style>/ig, '').toString();
             }
             html += `</div></div>`;
         }
         return {html:html,readMsg:readMsg};
     },
     _getAttachmentLists:function (attachmentLists,index=0,record_type) {
         let json = {
             value:  attachmentLists,
             dinput_type: '9',
             is_view: 0,
             record_type:record_type
         };
         let attachmentControl = new AttachmentControl({data: json, events: {changeValue:function(data){}}});
         attachmentControl.render($(this.el.find('.attachment-lists')[index]));
     },
     _getHtml:function (data) {
         return `<h3 class="msg-title">${data.title}</h3>
                 <pre class="text">${data.content}</pre>
                 <div class="attachment"><div class="attachment-lable">附件</div><div class="attachment-lists"></div></div> 
         `;
     },
     _speak:function (speak,readMsg) {
         if (speak) {
             let msg = new SpeechSynthesisUtterance(readMsg);
             msg.lang = 'zh';
             msg.voice = speechSynthesis.getVoices().filter(function(voice) {
                 return voice.name == 'Whisper';
             })[0];
             speechSynthesis.speak(msg);
         }
     }
 };
 
 export {systemMessageUtil};
 // systemMessageUtil.show();
 



// WEBPACK FOOTER //
// app/components/main/system-message/system-message.js